// Agrégat des traductions du mode Lite, branché dans translations.ts sous `lite`.
// Un fichier par page : FR et EN côte à côte, l'anglais typé sur le français
// (une clé manquante en EN casse la compilation).
import * as common from "./common";
import * as dashboard from "./dashboard";
import * as journal from "./journal";
import * as stats from "./stats";
import * as pfm from "./pfm";
import * as accounts from "./accounts";
import * as accountDetail from "./accountDetail";
import * as sessions from "./sessions";
import * as edgy from "./edgy";
import * as onboarding from "./onboarding";
import * as settings from "./settings";
import * as discipline from "./discipline";
import * as reports from "./reports";

export const liteFr = {
  ...common.fr,
  dashboard: dashboard.fr,
  journal: journal.fr,
  stats: stats.fr,
  pfm: pfm.fr,
  accounts: accounts.fr,
  accountDetail: accountDetail.fr,
  sessions: sessions.fr,
  edgy: edgy.fr,
  onboarding: onboarding.fr,
  settings: settings.fr,
  discipline: discipline.fr,
  reports: reports.fr,
};

export const liteEn: typeof liteFr = {
  ...common.en,
  dashboard: dashboard.en,
  journal: journal.en,
  stats: stats.en,
  pfm: pfm.en,
  accounts: accounts.en,
  accountDetail: accountDetail.en,
  sessions: sessions.en,
  edgy: edgy.en,
  onboarding: onboarding.en,
  settings: settings.en,
  discipline: discipline.en,
  reports: reports.en,
};

export type LiteTranslations = typeof liteFr;
